/**
 * The sortIndex for a new sub-task: one past the highest in use. Items with no
 * sortIndex count as -1, so the first sub-task gets 0 and no two get the same.
 *
 * @param checklist {Object[]}
 * @return {number}
 */
export function nextChecklistSortIndex(checklist) {
    return (
        (checklist || []).reduce((max, cl) => {
            const i = Number(cl?.sortIndex)
            return cl?.sortIndex !== null && cl?.sortIndex !== undefined && Number.isFinite(i) && i > max ? i : max
        }, -1) + 1
    )
}
